<template>
  <div class="settings">
    <SettingsNav :app="app" />

    <OnboardHint name="attributes" :app="app">
        <template slot="content">
            <h4><i>🔨</i> What are Attributes?</h4>
            <p>Attributes are the columns that are displayed on the <router-link to="/">People</router-link> page.</p>
            <p>For each attribute, you can set the data type. This changes the way that data can be edited.</p>
            <p>It is safe to delete an attribute; the underlying data will not deleted.</p>
        </template>
        <template slot="button">
            Thanks! <span class="hint inline">and hide this message</span>
        </template>
    </OnboardHint>

    <div class="table-wrapper">
        <table class="table">
            <thead>
                <tr>
                    <th><a>Display Name</a></th>
                    <th><a>Type</a></th>
                    <th class="no-padding has-checkbox"></th>
                </tr>
            </thead>

            <tbody>
                <tr v-for="(column, index) in app.columns" :key="'column-' + index">
                    <td>
                        <!-- <input type="text" v-model="column.name" @change="saveColumns"> -->
                        <a>{{column.name}}</a>
                    </td>
                    <td>
                        <select v-model="column.type" @change="saveColumns">
                            <option value="text">Text</option>
                            <option value="email">Email</option>
                            <option value="tel">Telephone</option>
                            <option value="address">Address</option>
                            <option value="checkbox">Checkbox</option>
                            <option value="date">Date</option>
                        </select>
                    </td>
                    <td class="has-checkbox align-center">
                        <a v-on:click="removeColumn(column)" href="javascript:;">
                            <font-awesome-icon icon="trash" />
                        </a>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <br>

    <button v-on:click="addColumn()">
        + Add Column
    </button>
  </div>
</template>

<script>
import SettingsNav from '@/pods/settings-nav/component.vue';
import OnboardHint from '@/pods/onboard-hint/component.vue';

export default {
  name: 'settings',
  props: ['app'],
  components: {
    OnboardHint,
    SettingsNav
  },
  methods: {
    addColumn() {
        var _ = this;

        _.app.columns.push({
            name: prompt('What is the name of this attribute?'),
            type: 'text'
        });

        _.saveColumns();
    },

    removeColumn(column) {
        var _ = this;

        if (confirm('Are you sure you want to delete this column?')) {
            _.app.columns.splice(_.app.columns.indexOf(column), 1);
            _.saveColumns();
        }
    },

    saveColumns() {
        var _ = this;

        return _.app.getSetting('columns', function(err, setting) {
            setting.value = _.app.columns;

            _.app.requester.request({
                controller: 'settings',
                action: 'save',
                setting: setting
            });
        });
    }
  }
};
</script>
